import React, { useState } from 'react';
import api from '../RefreshToken/RefreshToken';
import { API } from '../../constants';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import CloseImage from "../../images/fi_x.svg";
import { maskNumber } from "../../helpers/maskNumber";
import PhoneNumberInput from '../Inputs/PhoneNumberInput';

const Login = ({setIsModalOpen}) => {
    const navigate = useNavigate()
    // const [isModalOpen, setIsModalOpen] = useState(false);
    const [register, setRegister] = useState(false);
    const [countryCode, setCountryCode] = useState("+998");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [middleName, setMiddleName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [gender, setGender] = useState("");
    const [laungageReg, setLaungageReg] = useState("");
    const [otpError, setOtpError] = useState(false);
    const { t, i18n } = useTranslation();
    const [otp, setOtp] = useState({ visible: false, code: "", correctOtp: "" });
    const [forget, setForget] = useState(false)

    const handleSubmit = (event) => {
        event.preventDefault();
        if (register) {
            api
                .post(`${API}/register`, {
                    phone_number: countryCode + phoneNumber,
                    first_name: firstName,
                    last_name: lastName,
                    middle_name: middleName,
                    gender: gender,
                    exam_language: laungageReg,
                    email: email,
                    password,
                })
                .then((response) => {
                    setOtp({ ...otp, visible: true });

                    api.post(`${API}/send-otp`, {
                        "phone_number": `${countryCode}${phoneNumber}`
                    }
                    ).then((response) => {
                        toast.success("Verification successfully sent!");
                    })
                    // localStorage.setItem("token", response.data.access_token);
                    // setIsModalOpen(false);
                    // navigate("/");
                })
                .catch((error) => {
                    toast.error(error?.response?.data?.detail);
                });
        } else {

            api
                .post(`${API}/login`, {
                    phone_number: countryCode + phoneNumber,
                    password,
                })
                .then((response) => {
                    localStorage.setItem("token", response.data.access_token);
                    localStorage.setItem("studentRefreshToken", response.data.refresh_token)
                    setIsModalOpen(false);
                    navigate("/");
                })
                .catch((error) => {
                    toast.error("Check your credentials!");
                    console.error("Error:", error.response ? error.response.data : error.message);
                });
        }
    };

    const handleOtpSubmit = (event) => {
        event.preventDefault();

        api.post(`${API}/verify-otp`, {
            "phone_number": `${countryCode}${phoneNumber}`,
            "otp": otp?.code
        }).then(() => {
            api
                .post(`${API}/login`, { phone_number: countryCode + phoneNumber, password })
                .then((response) => {
                    localStorage.setItem("token", response.data.access_token)
                    localStorage.setItem("studentRefreshToken", response.data.refresh_token)
                    toast.success("Loged in!");
                    setIsModalOpen(false);
                    setPassword("");
                    setPhoneNumber("");
                    setOtp({ visible: false, code: "", correctOtp: "" });
                })
                .catch((error) => {
                    toast.error("Check your credentials!");
                    console.error(error);
                });
        }).catch((error) => {
            setOtpError(true);
        })
    };

    const handleForget = (() => {
        // setIsModalOpen(false);
        setRegister(false);
        setForget(true);
    })

    const handleChangeTab = (type) => {
        setRegister(type === "register");
        setPhoneNumber(null);
        setPassword("");
    }
    const handleGenderChange = (event) => {
        setGender(event.target.value);
    };

    return (
        <div>
            <div className="modalLogin">
                <div className="modalLogin-content">
                    <div className="modalLogin-title">
                        <h1 className="login-title"
                            style={{ marginBottom: "10px" }}>{otp.visible ? t("enterCode") : register ? t("register") : !forget ? t("signIn") : t("resetPassword")}</h1>
                        <div onClick={(e) => { setIsModalOpen(false); setForget(false) }} className="close">
                            <img src={CloseImage} alt={t("closeAlt")} />
                        </div>
                    </div>

                    {!otp.visible && !forget && (
                        <div className="tab-auth">
                            <div onClick={() => handleChangeTab("login")}
                                className={register ? "tab-auth-item" : "tab-auth-item active"}>
                                <p>{t("login")}</p>
                            </div>
                            <div onClick={() => handleChangeTab("register")}
                                className={register ? "tab-auth-item active" : "tab-auth-item"}>
                                <p>{t("register")}</p>
                            </div>
                        </div>
                    )}

                    {otp.visible ? (
                        <form onSubmit={handleOtpSubmit}>
                            <input
                                required
                                name="otp"
                                className="modalLogin-input input"
                                placeholder={t("enterOtpCode")}
                                type="text"
                                value={otp.code}
                                onChange={(e) => setOtp({ ...otp, code: e.target.value })}
                            />
                            <div className="otp-info">
                                <p>{t("otpSentMessage")}</p>
                                <p className="otp-info-number">{maskNumber(phoneNumber)}</p>
                                <p className="otp-timer">00:59</p>
                            </div>
                            {otpError && <p style={{ color: "red" }}>{t("invalidOtp")}</p>}
                            <button type="submit" className="submit otp-btn">{t("confirm")}</button>
                        </form>
                    ) : register ? (
                        <form onSubmit={handleSubmit}>
                            <input
                                required
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value)}
                                name="firstName"
                                className="modalLogin-input input"
                                placeholder={t("firstName")}
                                type="text"
                            />
                            <input
                                required
                                value={lastName}
                                onChange={(e) => setLastName(e.target.value)}
                                name="lastName"
                                className="modalLogin-input input"
                                placeholder={t("lastName")}
                                type="text"
                            />
                            <input
                                required
                                value={middleName}
                                onChange={(e) => setMiddleName(e.target.value)}
                                name="middleName"
                                className="modalLogin-input input"
                                placeholder={t("middleName")}
                                type="text"
                            />
                            <div>
                                <div>{t("chooseGender")}</div>
                                <label className="gender-input">
                                    <input
                                        type="radio"
                                        name="gender"
                                        value="M"
                                        checked={gender === "M"}
                                        onChange={handleGenderChange}
                                    />
                                    {t("male")}
                                </label>
                                <label>
                                    <input
                                        type="radio"
                                        name="gender"
                                        value="F"
                                        checked={gender === "F"}
                                        onChange={handleGenderChange}
                                    />
                                    {t("female")}
                                </label>
                            </div>
                            <select
                                className="modalLogin-input input"
                                value={laungageReg}
                                onChange={(e) => setLaungageReg(e.target.value)}
                            >
                                <option hidden>{t("studyLanguage")}</option>
                                <option value="uz">{t("languageUz")}</option>
                                <option value="ru">{t("languageRu")}</option>
                                <option value="uk">{t("languageUk")}</option>
                                <option value="en">{t("languageEn")}</option>
                            </select>
                            <PhoneNumberInput countryCode={countryCode} setCountryCode={setCountryCode}
                                phoneNumber={phoneNumber} setPhoneNumber={setPhoneNumber} />
                            <input
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                name="email"
                                className="modalLogin-input input"
                                placeholder={t("emailPlaceholder")}
                                type="email"
                            />
                            <input
                                required
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                name="password"
                                className="modalLogin-input input"
                                placeholder={t("passwordPlaceholder")}
                                type="password"
                            />
                            <div className="submit-block">
                                <button onClick={() => { setIsModalOpen(false); setForget(false) }} type="button"
                                    className="cancel">{t("cancel")}
                                </button>
                                <button type="submit" className="submit">{t("confirm")}</button>
                            </div>
                        </form>
                    ) : !forget ? (
                        <form onSubmit={handleSubmit}>
                            <PhoneNumberInput countryCode={countryCode} setCountryCode={setCountryCode}
                                phoneNumber={phoneNumber} setPhoneNumber={setPhoneNumber} />
                            <input
                                required
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                name="password"
                                className="modalLogin-input input"
                                placeholder={t("passwordPlaceholder")}
                                type="password"
                            />
                            <div className="forget-block">
                                <span onClick={handleForget} className="forget-password">{t("forgotPassword")}</span>
                            </div>
                            <div className="submit-block">
                                <button onClick={() => { setIsModalOpen(false); setForget(false) }} type="button"
                                    className="cancel">{t("cancel")}
                                </button>
                                <button type="submit" className="submit">{t("confirm")}</button>
                            </div>
                        </form>
                    ) : (
                        <form>
                            <PhoneNumberInput countryCode={countryCode} setCountryCode={setCountryCode}
                                phoneNumber={phoneNumber} setPhoneNumber={setPhoneNumber} />
                            <div className="submit-block">
                                <button onClick={() => { setIsModalOpen(false); setForget(false) }} type="button"
                                    className="cancel">{t("cancel")}
                                </button>
                                <button type="submit" className="submit">{t("confirm")}</button>
                            </div>
                        </form>
                    )}
                </div>
            </div>
        </div>
    );
}

export default Login;
